import { createFileRoute } from "@tanstack/react-router";
import { WorkflowDetail } from "@/components/views/workflow/WorkflowDetail";

export const Route = createFileRoute("/workflows/$workflowId")({
  component: WorkflowDetailRoute,
});

function WorkflowDetailRoute() {
  const { workflowId } = Route.useParams();
  return <WorkflowDetail slug={workflowId} />;
}
